import axios from 'axios'
import create, { GetState, SetState } from 'zustand'
import { handleAxiosError } from '../utils/error'
import { Axios } from '../utils/axios'

type BVNState = {
  loading: boolean
  setLoading: (loading: boolean) => void
  setBVN: (bvn: string) => void
  bvn: string
  verifyDetails: (values: { dob: string; last_4_digit: string }) => any
  BVNdetails?: any
  email: string
  phone_number?: string
  reset: any
}

const defaultState = {
  loading: false,
  bvn: '',
  email: ''
}

const BVNStore = (set: SetState<BVNState>, get: GetState<BVNState>) => ({
  ...defaultState,
  setBVN: async (bvn: string) => {
    set({ loading: true })
    try {
      const { data } = await Axios.post(`bvn/${bvn}/init`, { bvn })
      set({ loading: false, phone_number: data.data.phone_number })
    } catch (error: any) {
      set({ loading: false })
      throw new Error(error)
    }
    set({ bvn })
  },
  reset: () => {
    set(defaultState)
  },
  setLoading: (loading: boolean) => {
    set({ loading })
  },
  verifyDetails: async (values: any) => {
    set({ loading: true, email: values.email })
    const { bvn } = get()
    delete values.email
    try {
      const { data } = await Axios.post(`bvn/${bvn}`, values)
      set({ loading: false, BVNdetails: data.data })
      return true
    } catch (error: any) {
      console.log(error)
      set({ loading: false })
      handleAxiosError(error)
      return Promise.reject(
        error?.response?.data?.message ? error.response.data.message : error.message
      )
    }
  }
})

const useBVNStore = create<BVNState>(BVNStore)

export default useBVNStore
